export enum PhotoType {
  WarrantTaskPhotoByEngineer,
  SurveyWarrantTaskPhotoByEngineer,
  SurveyWarrantTaskPhotoByDispatcher,
  ContractPhotoByContractor
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/photoDataPhotoType.ts